import RegistrarNewAccountScreen from './RegistrarNewAccountScreen.jsx';
export default RegistrarNewAccountScreen;
